import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { filter, set } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @mui
import dayjs from 'dayjs';
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';

import '../css/style.css';
import { CSVLink } from 'react-csv';

import Ticketmodel from '../components/models/Ticket/Ticketmodel';
import { Addcomment, getOneticket, getTicket, updateTicket } from '../redux/actions/Ticketaction';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

export default function Commentpage() {
  const dispatch = useDispatch();
  const ticket = useSelector((state) => state?.Ticket?.getSingleTicket?.data);
  const [messages, setMessages] = useState([]);
  const [newMeassage, setNewMessage] = useState([]);
  const [ticketstatus, setticketStatus] = useState('open');

  const { userid } = useParams();
  const { ticketid } = useParams();

  console.log('ticket', ticket);

  const handleChange = (e) => {
    setticketStatus(e.target.value);
    const obj = {
      status: ticketstatus,
    };
    dispatch(updateTicket(userid, ticketid, obj));
  };

  const handleMessageSend = () => {
    setNewMessage('');
    const obj = {
      userId: userid,
      ticketId: ticketid,
      comment: newMeassage,
    };
    dispatch(Addcomment(obj)).then((res) => {
      if (res.status === 200) {
        dispatch(getOneticket(userid, ticketid));
        if (newMeassage.trim() === '') return;
        const updatedMessages = [...messages, newMeassage];
        setMessages(updatedMessages);
      }
    });
  };

  useEffect(() => {
    dispatch(getOneticket(userid, ticketid));
  }, []);

  return (
    <>
      <Helmet>
        <title> Employee | Minimal UI </title>
      </Helmet>
      <Container>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'end',
            minHeight: '400px',
            maxHeight: '68vh',
          }}
        >
          <Box>
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>TicketId : </Box>
              <Box>{ticket?.ticketId}</Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Box sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>Status : </Box>
              <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <Box>{ticket?.status}</Box>
                {/* <select value={status} onChange={(e) => handleChange(e)}>
                  <option value="open">open</option>
                  <option value="close">close</option>
                  <option value="inprogress">in progress</option>
                </select> */}
                <Box>
                  <Select
                    id="demo-simple-select"
                    value={ticket?.status}
                    size="small"
                    style={{ padding: '1px 2px', fontSize: '0.75rem' }}
                    onChange={handleChange}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="open">Open</MenuItem>
                    <MenuItem value="closed">Close</MenuItem>
                    <MenuItem value="inprogress">In Progress</MenuItem>
                  </Select>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>Time : </Box>
              <Box> {dayjs(ticket?.timestamp)?.format('DD-MM-YYYY HH:MM')}</Box>
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>Data : </Box>
              <Box>{ticket?.data}</Box>
            </Box>
          </Box>
          <Paper elevation={3} sx={{ flexGrow: 1, p: 2, mb: 2, overflowY: 'auto' }}>
            {ticket?.comments?.map((index) => (
              <div
                style={{ backgroundColor: '', padding: '4px', display: 'flex', gap: '6px', marginTop: '10px' }}
                // key={index}
              >
                <Avatar sx={{ height: '25px', width: '25px', fontSize: '12px' }} />
                <Box>
                  <Box sx={{ fontSize: '14px', px: '6px', fontWeight: 'bold' }}>{index?.userName}</Box>
                  <Box sx={{ backgroundColor: '#F4F6F8', padding: '6px', borderRadius: '8px' }}>{index?.comment}</Box>
                </Box>
              </div>
            ))}
          </Paper>
          <Box sx={{ display: 'flex' }}>
            <TextField
              label="Type a comment"
              variant="outlined"
              sx={{ flexGrow: 1, mr: 2 }}
              value={newMeassage}
              onChange={(e) => setNewMessage(e.target.value)}
            />
            <Button variant="contained" color="primary" onClick={handleMessageSend}>
              Send
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
}

// const dispatch = useDispatch();
